import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import './ApiAvailState.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import './ApiBaseDataSource.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import './ApiClientType.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import './ApiFuelType.js';
import './ApiGender.js';
import { ApiImageContainerFromJSON, ApiImageContainerToJSON } from './ApiImageContainer.js';
import './ApiImageType.js';
import './ApiInventory.js';
import './ApiItemType.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiItineraryFromJSON(json) {
    return ApiItineraryFromJSONTyped(json);
}
function ApiItineraryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'numberOfDay': !exists(json, 'numberOfDay') ? undefined : json['numberOfDay'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'longDescription': !exists(json, 'longDescription') ? undefined : json['longDescription'],
        'mainImage': !exists(json, 'mainImage') ? undefined : ApiImageContainerFromJSON(json['mainImage']),
    };
}
function ApiItineraryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'numberOfDay': value.numberOfDay,
        'title': value.title,
        'longDescription': value.longDescription,
        'mainImage': ApiImageContainerToJSON(value.mainImage),
    };
}

export { ApiItineraryFromJSON, ApiItineraryFromJSONTyped, ApiItineraryToJSON };
//# sourceMappingURL=ApiItinerary.js.map
